import React, { ReactElement } from "react";
import Styles from "../styles/Styles";
import MenuIcon from "@mui/icons-material/Menu";
import { DefaultLogo, FontStyles } from "../../../components";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
type CustomHeaderProps = {};

function Footer({}: CustomHeaderProps) {
  return (
    <Styles.Container id="footer">
      <Styles.PeriodText>
        TESTE AUTENTICAÇÃO COMO HÓSPEDE ACOMPANHANTE
      </Styles.PeriodText>
    </Styles.Container>
  );
}

export default Footer;
